import React from 'react';
import { connect } from 'react-redux';

import TextEditor from 'components/TextEditor';
import * as actions from 'actions';
import { getMailTextEditing, getMailEmojis } from 'selectors';
import './style.scss';

export const MailTeamMessageEditor = props => {

  return (
    <div className="wrapper-narrow">
      <TextEditor
        {...props}
        maxChars={process.env.KOOTH_MAX_CHARS}
        isExpanded
        title={__('members.mail.mailTeam.title')}
        placeholder={__('members.mail.mailTeam.contentPlaceholder')}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...getMailTextEditing(state, 'teamMessage'),
    showsEmojis: getMailEmojis(state, 'teamMessage').areVisible
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTextUpdate: text => {
      dispatch(actions.mailmailMessageTheTeamEditingUpdateText({ text }));
    },
    onSubmit: text => {
      dispatch(actions.mailMessageTheTeam(text));
    },
    onWillUnmount: () => {
      dispatch(actions.mailEmojisHide('teamMessage'));
      dispatch(actions.mailmailMessageTheTeamEditingReset());
    },
    onEmojisToggled: showsEmojis => {
      if(showsEmojis) {
        dispatch(actions.mailEmojisHide('teamMessage'));
      }
      else {
        dispatch(actions.mailEmojisShow('teamMessage'));
      }
    },
    onEmojiSelected: (text, emojiShortName, selectionStart) => {
      dispatch(actions.mailmailMessageTheTeamEditingUpdateText({ text, emojiShortName, selectionStart }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailTeamMessageEditor);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailTeamMessageEditor/index.js
 **/